<template>
    <b-avatar
        size="40"
        :src="userData"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon v-if="!userData" icon="UserIcon" size="22" />
      </b-avatar>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: '',
      avatarText,
    };
  },
  methods: {
    
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/horizontal-headerbar.css";
</style>
